module.exports = __webpack_public_path__ + "img/lanmo.e7c42639.jpg";